import React from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import DataImportTableWidget from '../../../widgets/auditWidgets/auditReportSummaryWidgets/DataImportTableWidget'

export default function AuditFileImportGeade() {
  return (
    <div>
      <SidebarProposal isAudit>
        <ContentHeader header={'นำเข้าข้อมูลเกรด'} subHeader={''} isNotCallApi isShowGoButton />

        <DataImportTableWidget type="imp03" />
        <br />
      </SidebarProposal>
    </div>
  )
}
